import React, { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { Alert, Box, Button, CircularProgress, Container, Dialog, DialogActions, DialogContent, FormControl, Grid, IconButton, InputLabel, LinearProgress, MenuItem, Paper, Select, Switch, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, 
  TableRow, TextField, Toolbar, Typography 
} from '@mui/material';

import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import UndoIcon from '@mui/icons-material/Undo';

import { NavbarInicio } from '../ui/NavbarInicio';

import { usePages } from '../../hooks/usePages';

import { TablePaginationActions } from '../../helpers/TablePaginationActions';

import { ActualizarAsentamiento, AgregarAsentamiento, Asentamientos } from '../../actions/catalogos/asentamientoActions';

import { ObtenerEstados } from '../../actions/catalogos/estadoActions';
import { ObtenerMunicipios } from '../../actions/catalogos/municipioActions';
import { ObtenerZonas } from '../../actions/catalogos/zonaActions';
import { ObtenerTiposAsentamientos } from '../../actions/catalogos/tipoAsentamientoActions';
import { ObtenerCiudades } from '../../actions/catalogos/ciudadActions';

import { usePermisos } from '../../hooks/usePermisos';

import { NotFoundScreen } from '../auth/NotFoundScreen';
    
export const AsentamientoScreen = ( ) => {

    const { tipoUsuario, loading } = usePermisos();

    const navigate = useNavigate();

    const [errors, setErrors] = useState({ });

    const [rows, setRows] = useState( [ ] );

    const [estado, setEstado] = useState( 0 );
    const [estadoArray, setEstadoArray] = useState( [ ] );

    const [municipio, setMunicipio] = useState( 0 );
    const [municipioArray, setMunicipioArray] = useState( [ ] );

    const [ciudad, setCiudad] = useState( 0 );
    const [ciudadArray, setCiudadArray] = useState( [ ] );

    const [zona, setZona] = useState( 0 );
    const [zonaArray, setZonaArray] = useState( [ ] );

    const [tipoAsentamiento, setTipoAsentamiento] = useState( 0 );
    const [tipoAsentamientoArray, setTipoAsentamientoArray] = useState( [ ] );

    const [codigoPostal, setCodigoPostal] = useState( '' );
    const [descripcion, setDescripcion] = useState( '' );
    const [idReferencia, setIdReferencia] = useState( '' );
    const [opcion, setOpcion] = useState( '' );

    const [loadingTable, setLoadingTable] = useState( true );
    const [loadingSave, setLoadingSave] = useState( false );
    const [openModal, setOpenModal] = useState( false );
  
    const [page, rowsPerPage, handleChangePage, handleChangeRowsPerPage] = usePages();
  
    const handleChangeSwitch = ( id, value ) => {

        const newRows = rows.map( (row) => { if(row.idAsentamiento === id){ row.activo = value; return row; } else{ return row; } } );
        setRows( newRows );        

        const asentamiento = rows.filter( function(row){ return row.idAsentamiento === id; } );
        cambiarEstatus( asentamiento[0] );
    }

    const handleOpenModal = () => {
        setOpenModal(true);
    }

    const handleCloseModal = () => {
        setOpenModal(false);
        setErrors( { } );
    }

    const cambiarEstatus = async ( { idAsentamiento, clave, codigoPostal, descripcion, activo, estado, municipio, ciudad, zona, tipoAsentamiento } ) => {

        const params = {
            idAsentamiento,
            clave,
            codigoPostal,
            idEstado: estado.idEstado,
            idMunicipio: municipio.idMunicipio,
            idCiudad: ciudad ? ciudad.idCiudad : 0,
            idZona: zona.idZona,
            idTipoAsentamiento: tipoAsentamiento.idTipoAsentamiento,
            descripcion,
            activo,
        };

        await ActualizarAsentamiento( params );
    }

    const AgregarRegistro = () => {

        setEstado( 0 );
        setMunicipio( 0 );
        setCiudad( 0 );
        setZona( 0 );
        setTipoAsentamiento( 0 );
        setCodigoPostal( '' );
        setDescripcion( '' );        

        setOpcion( 'agregar' );
        setIdReferencia( 0 );

        handleOpenModal();
    }

    const EditarRegistro = ( id, descripcion, codigoPostal, idEstado, idMunicipio, idCiudad, idZona, idTipoAsentamiento ) => {
        
        setCodigoPostal( codigoPostal );
        setDescripcion( descripcion );
        setEstado( idEstado );
        
        setZona( idZona );
        setTipoAsentamiento( idTipoAsentamiento );

        setOpcion( 'editar' );
        setIdReferencia( id );

        asyncMunicipiosEdit( idEstado, idMunicipio );
        asyncCiudadEdit(idEstado, idMunicipio, idCiudad);

        handleOpenModal();
    }

    const Guardar = async () => {

        const valid = validateFiels();

        if( !valid ){
            return false;
        }
        
        setLoadingSave( true );

        if( opcion === 'agregar' ){
            const params = {
                idAsentamiento: 0,
                clave: '',
                codigoPostal: codigoPostal,
                descripcion: descripcion.trim(),
                idEstado: estado,
                idMunicipio: municipio,
                idCiudad: ciudad,
                idZona: zona,
                idTipoAsentamiento: tipoAsentamiento,
                activo: true,
            };

            await AgregarAsentamiento( params ).then( response => {
                if( response ){
                    if( response.status === 200){
                        if( response.data ){

                            setTimeout(() => {                                
                            
                                setRows([ 
                                    ...rows,  
                                    {
                                        idAsentamiento: response.data.idAsentamiento,
                                        idEstado: response.data.idEstado,
                                        idMunicipio: response.data.idMunicipio,
                                        idCiudad: response.data.idCiudad ?? '',
                                        idZona: response.data.idZona,
                                        idTipoAsentamiento: response.data.idTipoAsentamiento,

                                        estado: response.data.estado,
                                        municipio: response.data.municipio,
                                        ciudad: response.data.municipio,
                                        zona: response.data.zona,
                                        tipoAsentamiento: response.data.tipoAsentamiento,

                                        clave: response.data.clave,
                                        codigoPostal: codigoPostal,
                                        descripcion: descripcion,
                                        activo: true
                                    }
                                ]);  

                                handleCloseModal();

                                setLoadingSave( false );

                            }, 1000);
                        } 
                    }
                }
            });
        }

        if( opcion === 'editar' ){
            const asentamiento = rows.filter( function(row){ return row.idAsentamiento === idReferencia; } )[0];

            const params = {
                idAsentamiento: idReferencia,
                idEstado: estado,
                idMunicipio: municipio,
                idCiudad: ciudad,
                idZona: zona,
                idTipoAsentamiento: tipoAsentamiento,
                clave: asentamiento.clave,
                codigoPostal: codigoPostal,  
                descripcion: descripcion.trim(),                
                activo: asentamiento.activo,
            };
    
            await ActualizarAsentamiento( params ).then( response => {
                if( response ){
                    if( response.status === 200){
                        
                        setTimeout(() => {
                            
                            setTimeout(() => {

                                const newRows = rows.map( (row) => { 
                                    if(row.idAsentamiento === idReferencia){ 
                                        row.clave = response.data.clave; 
                                        row.codigoPostal = codigoPostal; 
                                        row.descripcion = descripcion; 
                                        row.estado = response.data.estado;
                                        row.municipio = response.data.municipio;
                                        row.ciudad = response.data.ciudad;
                                        row.zona = response.data.zona;
                                        row.tipoAsentamiento = response.data.tipoAsentamiento;
                                        return row; 
                                    } 
                                    else{ 
                                        return row; 
                                    } 
                                });

                                setRows( newRows ); 
                                
                                handleCloseModal();

                                setLoadingSave( false );

                            }, 1000);

                        }, 1000);
                    }
                }                
            });
        }
    }

    const validateFiels = () => {
        
        setErrors( { } );

        let valid = true;
        let errores = {};

        if( descripcion.trim() === '' ){
            valid = false;
            errores.descripcion = 'Debes escribir la descripción';
        } 
        
        if( codigoPostal === '' || codigoPostal === 0 ){
            valid = false;
            errores.codigoPostal = 'Debes escribir el código postal';
        } 

        if( estado === 0 ){
            valid = false;
            errores.estado = 'Debes seleccionar un estado';
        }  

        if( estado !== 0 && municipio === 0 ){
            valid = false;
            errores.municipio = 'Debes seleccionar un municipio';
        }  

        if( zona === 0 ){
            valid = false;
            errores.zona = 'Debes seleccionar una zona';
        }  

        if( tipoAsentamiento === 0 ){
            valid = false;
            errores.tipoAsentamiento = 'Debes seleccionar un tipo de asentamiento';
        }  
        
        setErrors( errores );
        return valid;
    } 

    const asyncMunicipiosEdit = async (idEstado, idMunicipio) => {
        
        setCiudad( 0 );

        await ObtenerMunicipios( idEstado ).then( response => {
            if(response){
                if( response.status === 200){
                    setMunicipioArray( response.data );  
                    
                    setMunicipio( idMunicipio );
                }
            }
        });

    }

    const asyncCiudadEdit = async (idEstado, idMunicipio, idCiudad) => {
        
        const params = {
            idEstado,
            idMunicipio
        }

        await ObtenerCiudades( params ).then( response => {
            if(response){
                if( response.status === 200){
                    setCiudadArray( response.data );   

                    setCiudad( idCiudad );
                }
            }
        });
    }

    useEffect(() => {
        
        async function Obtener(){
            
            await Asentamientos().then(response => {
                
                if( response ){

                    if( response.status === 200 ){

                        setLoadingTable( false );
                        setRows( response.data );
                    }

                }
                
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {
        
        async function Obtener(){
            
            await ObtenerEstados().then(response => {
                
                if( response ){
                    if( response.status === 200 ){
                        setEstadoArray( response.data );
                    }
                }
                
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {
        
        async function Obtener(){     

            setCiudad( 0 );
            setMunicipio( 0 );

            if( estado !== 0 ){       
                await ObtenerMunicipios( estado ).then( response => {
                    if(response){
                        if( response.status === 200){
                            setMunicipioArray( response.data );   
                        }
                    }
                });
            }

        }

        Obtener();

    }, [ estado ]);

    useEffect(() => {
        
        async function Obtener(){    
                
            await ObtenerZonas().then( response => {
                if(response){
                    if( response.status === 200){
                        setZonaArray( response.data );   
                    }
                }
            });

        }

        Obtener();

    }, [ ]);
    
    useEffect(() => {
        
        async function Obtener(){       
            
            await ObtenerTiposAsentamientos().then( response => {
                if(response){
                    if( response.status === 200){
                        setTipoAsentamientoArray( response.data );   
                    }
                }
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {
        
        async function Obtener(){    

            setCiudad( 0 );
              
            if( estado !== 0 && municipio !== 0){

                const params = {
                    idEstado: estado,
                    idMunicipio: municipio,
                };

                await ObtenerCiudades( params ).then( response => {
                    if(response){
                        if( response.status === 200){
                            setCiudadArray( response.data );   
                        }
                    }
                });
            }

        }

        Obtener();

    }, [ estado, municipio ]);

    return (
        <>        

            <NavbarInicio />

            {
                ( !loading && tipoUsuario !== 3 )
                &&
                <NotFoundScreen />
            }

            {
                ( !loading && tipoUsuario === 3  )
                &&   
                <>

                    <Container maxWidth='xl' sx={{ mt: { md: '13em', xs: '11em' } }}>

                        <Box sx={{ pb: '2em', pl: { md: 10, xs: 1 }, pr: { md: 10, xs: 1 }, pt: 2 }} component={ Paper } >	

                            <Container maxWidth="lg">   

                                <Grid container spacing={3} sx={{ mt: 1 }} >  
                                        
                                    <Grid item md={6} xs={6} sx={{ textAlign: 'left' }}> 
                                        <Button type="button" startIcon={ <UndoIcon /> } variant='contained' color='inherit' sx={{ mt: 1 }} onClick={ () => navigate('/administracion/') }> 
                                            Regresar a los catálogos
                                        </Button> 
                                    </Grid>

                                    <Grid item md={6} xs={6} sx={{ textAlign: 'right' }}> 
                                        <Button type="button" startIcon={ <AddCircleOutlineRoundedIcon /> } variant="contained" sx={{ mt: 1 }} onClick={ AgregarRegistro }> 
                                            Agregar
                                        </Button> 
                                    </Grid>

                                </Grid>

                                <Grid container spacing={3} sx={{ mt: 1 }} >  
                                    
                                    <Grid item xs={12} md={12}> 

                                        <Toolbar sx={{ pl: { sm: 2 }, pr: { xs: 1, sm: 1 } }} >
                                            <Typography sx={{ flex: '1 1 100%' }} variant="h6" component="div" >
                                                Asentamiento
                                            </Typography>
                                        </Toolbar>

                                        <TableContainer>

                                            <Table sx={{ minWidth: 500 }} >
                                                <TableHead>
                                                    <TableRow>        
                                                        <TableCell style={{ width:'5%' }}> ID </TableCell>
                                                        <TableCell style={{ width:'5%' }}> CLAVE </TableCell>
                                                        <TableCell style={{ width:'20%' }}> DESCRIPCIÓN </TableCell>
                                                        <TableCell style={{ width:'10%' }}> CÓDIGO POSTAL </TableCell>
                                                        
                                                        <TableCell style={{ width:'20%' }}> ESTADO </TableCell>
                                                        <TableCell style={{ width:'20%' }}> MUNICIPIO </TableCell>
                                                                                                        
                                                        <TableCell style={{ width:'10%' }}> HABILITADO </TableCell>
                                                        <TableCell style={{ width:'10%' }}> EDITAR </TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                {
                                                    (rowsPerPage > 0
                                                        ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                        : rows
                                                    ).map((row) => (
                                                        <TableRow key={ row.idAsentamiento} >
                                                        
                                                            <TableCell style={{ fontWeight: 'bold' }}>
                                                                { row.idAsentamiento }
                                                            </TableCell>

                                                            <TableCell>
                                                                { row.clave }
                                                            </TableCell>

                                                            <TableCell>
                                                                { row.descripcion }
                                                            </TableCell>

                                                            <TableCell>
                                                                { row.codigoPostal }
                                                            </TableCell>

                                                            <TableCell>
                                                                { row.estado.descripcion }
                                                            </TableCell>

                                                            <TableCell>
                                                                { row.municipio.descripcion }
                                                            </TableCell>

                                                            <TableCell>
                                                                {
                                                                    row.activo 
                                                                    ? 
                                                                    (
                                                                        <Switch 
                                                                            inputProps={ { 'aria-label': 'Switch demo'} } 
                                                                            checked={ row.activo } 
                                                                            onChange={ ( e ) => handleChangeSwitch( row.idAsentamiento, e.target.checked ) }
                                                                        />
                                                                    ) 
                                                                    :                                           
                                                                    ( 
                                                                        <Switch 
                                                                            inputProps={ { 'aria-label': 'Switch demo'} } 
                                                                            checked={ row.activo } 
                                                                            onChange={ ( e ) => handleChangeSwitch( row.idAsentamiento, e.target.checked ) }
                                                                        />
                                                                    )
                                                                }
                                                            </TableCell>

                                                            <TableCell>
                                                                <IconButton 
                                                                        color="primary" 
                                                                        aria-label="edit" 
                                                                        component="span" 
                                                                        onClick={ () => EditarRegistro(                                                                 
                                                                            row.idAsentamiento, row.descripcion, row.codigoPostal, row.estado.idEstado, row.municipio.idMunicipio, 
                                                                            row.ciudad ? row.ciudad.idCiudad : 0, row.zona.idZona, row.tipoAsentamiento.idTipoAsentamiento      
                                                                        )}
                                                                    >                                                        
                                                                    <EditIcon />
                                                                </IconButton>  
                                                            </TableCell>

                                                        </TableRow>
                                                    ))
                                                }

                                                { 
                                                    rows.length === 0 && (
                                                        <TableRow style={{ height: 53 }}>

                                                            <TableCell colSpan={10} align="center"> 
                                                                {
                                                                    loadingTable
                                                                    ?
                                                                        <CircularProgress size={40} sx={{ mt: 2, mb: 2 }} />
                                                                    :
                                                                        ''
                                                                }
                                                                {
                                                                    !loadingTable && rows.length === 0
                                                                    ?
                                                                        'No se encontraron usuarios'
                                                                    :
                                                                        ''
                                                                }
                                                            </TableCell>

                                                        </TableRow>
                                                    )
                                                }

                                                </TableBody>

                                                <TableFooter>
                                                    <TableRow>
                                                        <TablePagination
                                                            rowsPerPageOptions={[ 5, 10, 15, 20, 25, 50, 100 ]}
                                                            colSpan={11}
                                                            count={rows.length}                                        
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}                                                                                
                                                            onPageChange={ handleChangePage }
                                                            onRowsPerPageChange={ handleChangeRowsPerPage }
                                                            ActionsComponent={ TablePaginationActions }

                                                            labelRowsPerPage="Filas por página"                                            
                                                            labelDisplayedRows={
                                                                ({ from, to, count }) => {
                                                                return '' + from + '-' + to + ' de ' + count
                                                                }
                                                            }  
                                                        />
                                                    </TableRow>
                                                </TableFooter>
                                            </Table>

                                        </TableContainer>

                                    </Grid>

                                </Grid>

                            </Container>

                        </Box>

                    </Container>

                    <Dialog open={ openModal } maxWidth='sm' fullWidth={true}>       
                    
                        <DialogContent>
                            
                            <Grid container spacing={3}>
            
                                <Grid item md={6} sm={12}>

                                    <FormControl fullWidth sx={{ mt: 3 }} >
                                        <InputLabel id="select-estado-label">Estado</InputLabel>
                                    
                                        <Select
                                            labelId="select-estado-label"
                                            id="select-estado"                                            
                                            label="Estado"
                                            name="estado"
                                            value={ estado }                                
                                            onChange={ ( e ) => { setEstado( e.target.value ) } }
                                        >
                                            <MenuItem key={0} value={0}>Seleccione una opción</MenuItem>
                                            {
                                                estadoArray.map( ( elem ) => (
                                                    <MenuItem key={ elem.idEstado } value={ elem.idEstado }> { elem.descripcion } </MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                    {   
                                        errors.estado && ( <Alert color='warning' severity="warning" variant="filled" style={{ marginTop: '1em' }} > { errors.estado } </Alert> )
                                    }     

                                </Grid>

                                <Grid item md={6} sm={12}>

                                    <FormControl fullWidth sx={{ mt: 3 }} >
                                        <InputLabel id="select-municipio-label">Municipio</InputLabel>
                                    
                                        <Select
                                            labelId="select-municipio-label"
                                            id="select-municipio"                                            
                                            label="Municipio"
                                            name="municipio"
                                            value={ municipio }                                
                                            onChange={ ( e ) => { setMunicipio( e.target.value ) } }
                                            disabled={ estado === 0 }
                                        >
                                            <MenuItem key={0} value={0}>Seleccione una opción</MenuItem>
                                            {
                                                municipioArray.map( ( elem ) => (
                                                    <MenuItem key={ elem.idMunicipio } value={ elem.idMunicipio }> { elem.descripcion } </MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                    {   
                                        errors.municipio && ( <Alert color='warning' severity="warning" variant="filled" style={{ marginTop: '1em' }} > { errors.municipio } </Alert> )
                                    }          

                                </Grid>
                                        
                            </Grid>                    

                            <FormControl fullWidth sx={{ mt: 3 }} >
                                <InputLabel id="select-ciudad-label">Ciudad</InputLabel>
                            
                                <Select
                                    labelId="select-ciudad-label"
                                    id="select-ciudad"                                            
                                    label="Ciudad"
                                    name="ciudad"
                                    value={ ciudad }                                
                                    onChange={ ( e ) => { setCiudad( e.target.value ) } }
                                    disabled={ estado === 0 }
                                >
                                    <MenuItem key={0} value={0}>Seleccione una opción</MenuItem>
                                    {
                                        ciudadArray.map( ( elem ) => (
                                            <MenuItem key={ elem.idCiudad } value={ elem.idCiudad }> { elem.descripcion } </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                            <Grid container spacing={3}>
                            
                                <Grid item md={6} sm={12}>

                                    <FormControl fullWidth sx={{ mt: 3 }} >
                                        <InputLabel id="select-tipoAsentamiento-label">Tipo asentamiento</InputLabel>
                                    
                                        <Select
                                            labelId="select-tipoAsentamiento-label"
                                            id="select-tipoAsentamiento"                                            
                                            label="Tipo asentamiento"
                                            name="tipoAsentamiento"
                                            value={ tipoAsentamiento }                                
                                            onChange={ ( e ) => { setTipoAsentamiento( e.target.value ) } }
                                        >
                                            <MenuItem key={0} value={0}>Seleccione una opción</MenuItem>
                                            {
                                                tipoAsentamientoArray.map( ( elem ) => (
                                                    <MenuItem key={ elem.idTipoAsentamiento } value={ elem.idTipoAsentamiento }> { elem.descripcion } </MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                    {   
                                        errors.tipoAsentamiento && ( <Alert color='warning' severity="warning" variant="filled" style={{ marginTop: '1em' }} > { errors.tipoAsentamiento } </Alert> )
                                    }

                                </Grid>

                                <Grid item md={6} sm={12}>

                                    <FormControl fullWidth sx={{ mt: 3 }} >
                                        <InputLabel id="select-zona-label">Zona</InputLabel>
                                    
                                        <Select
                                            labelId="select-zona-label"
                                            id="select-zona"                                            
                                            label="Zona"
                                            name="zona"
                                            value={ zona }                                
                                            onChange={ ( e ) => { setZona( e.target.value ) } }
                                        >
                                            <MenuItem key={0} value={0}>Seleccione una opción</MenuItem>
                                            {
                                                zonaArray.map( ( elem ) => (
                                                    <MenuItem key={ elem.idZona } value={ elem.idZona }> { elem.descripcion } </MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                    {   
                                        errors.zona && ( <Alert color='warning' severity="warning" variant="filled" style={{ marginTop: '1em' }} > { errors.zona } </Alert> )
                                    }

                                </Grid>
                            
                            </Grid>
                            
                            <TextField
                                sx={{ mt: 3 }}
                                label={ 'Código postal' }
                                variant="outlined"             
                                fullWidth
                                value={ codigoPostal }
                                onChange={ ( e ) => { setCodigoPostal( e.target.value ) } }
                            />

                            {   
                                errors.codigoPostal && ( <Alert color='warning' severity="warning" variant="filled" style={{ marginTop: '1em' }} > { errors.codigoPostal } </Alert> )
                            }

                            <TextField
                                sx={{ mt: 3 }}
                                label='Descripción'
                                variant="outlined"                           
                                multiline
                                rows={4}                                        
                                fullWidth
                                value={ descripcion }
                                onChange={ ( e ) => { setDescripcion( e.target.value ) } }
                            />

                            {   
                                errors.descripcion && ( <Alert color='warning' severity="warning" variant="filled" style={{ marginTop: '1em' }} > { errors.descripcion } </Alert> )
                            }

                        </DialogContent>

                        <DialogActions>
                            <Button onClick={ handleCloseModal }> Cancelar </Button>
                            <Button onClick={ Guardar } variant='contained' startIcon={ <SaveIcon /> } > Guardar </Button>
                        </DialogActions>

                        <LinearProgress sx={{ display: loadingSave ? 'flex' : 'none' }} />

                    </Dialog>

                </>

            }

        </>
    )
}
